import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import {
  DELETE_SCENARIO_ASYNC as SMM_DELETE_SCENARIO_ASYNC,
  SAVE_SCENARIO_ASYNC,
} from 'containers/ScenarioForm/constants'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from '../../PartnerOptions/constants'

import {
  copyScenarioError,
  copyScenarioSuccess,
  createNewCampaignFromScenarioError,
  createNewCampaignFromScenarioSuccess,
  deleteScenarioError,
  deleteScenarioSuccess,
  fetchScenariosError,
  fetchScenariosSuccess,
} from './actions'
import {
  CATEGORY_FILTER_CHANGE,
  COPY_SCENARIO_ASYNC,
  CREATE_CAMPAIGN_FROM_SCENARIO_ASYNC,
  CREATED_BY_FILTER_CHANGE,
  DELETE_SCENARIO_ASYNC,
  LANGUAGES_FILTER_CHANGE,
  LEVEL_FILTER_CHANGE,
  PAGINATE_CHANGE,
  SCENARIOS_REQUEST_ASYNC,
  SEARCH_CHANGE,
  SORT_PROPERTY_CHANGE,
  TYPE_FILTER_CHANGE,
} from './constants'

const fetchScenariosEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(
      SCENARIOS_REQUEST_ASYNC.INITIATE,
      LANGUAGES_FILTER_CHANGE,
      TYPE_FILTER_CHANGE,
      LEVEL_FILTER_CHANGE,
      CATEGORY_FILTER_CHANGE,
      PAGINATE_CHANGE,
      SEARCH_CHANGE,
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      DELETE_SCENARIO_ASYNC.SUCCESS,
      SMM_DELETE_SCENARIO_ASYNC.SUCCESS,
      COPY_SCENARIO_ASYNC.SUCCESS,
      SAVE_SCENARIO_ASYNC.SUCCESS,
      SORT_PROPERTY_CHANGE,
      CREATED_BY_FILTER_CHANGE
    )
    .filter((action) => {
      if (
        action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS ||
        action.type === SMM_DELETE_SCENARIO_ASYNC.SUCCESS ||
        action.type === SAVE_SCENARIO_ASYNC.SUCCESS
      )
        return matchURL(URL_CONST.awarenessCenter.scenarios)
      else return true
    })
    .switchMap(() =>
      api.awarenessCenter
        .getScenarios(
          store.getState().awarenessCenter.scenarios.page || 1,
          store.getState().awarenessCenter.scenarios.sortProperty,
          store
            .getState()
            .awarenessCenter.scenarios.categoryFilter?.map((elem) => elem.label)
            .join(',') || 0,
          store
            .getState()
            .awarenessCenter.scenarios.languagesFilter.map((elem) => elem.value)
            .join(','),
          store
            .getState()
            .awarenessCenter.scenarios.typeFilter?.map((elem) => elem.value)
            .join(','),
          store
            .getState()
            .awarenessCenter.scenarios.levelFilter?.map((elem) => elem.value)
            .join(','),
          store
            .getState()
            .awarenessCenter.scenarios.createdByFilter?.map((elem) => elem.value)
            .join(','),
          store.getState().awarenessCenter.scenarios.search,
          store.getState().partnerOptions.selectedCompany?.value,
          !!store.getState().app.data.partner
        )
        .mergeMap((response) => Observable.of(fetchScenariosSuccess(response)))
        .catch((error) => Observable.of(epicsErrorHandler(fetchScenariosError, error)))
        .takeUntil(action$.ofType(SCENARIOS_REQUEST_ASYNC.CANCEL))
    )

const deleteScenarioEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(DELETE_SCENARIO_ASYNC.INITIATE).mergeMap((action) =>
    api.awarenessCenter
      .deleteScenario(
        action.payload.id,
        store.getState().partnerOptions.selectedCompany?.value,
        !!store.getState().app.data.partner
      )
      .map((response) => deleteScenarioSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(deleteScenarioError, error)))
      .takeUntil(action$.ofType(DELETE_SCENARIO_ASYNC.CANCEL))
  )

const copyScenarioEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(COPY_SCENARIO_ASYNC.INITIATE).mergeMap((action) =>
    api.awarenessCenter
      .copyScenario(action.payload.id, action.payload.companiesIds, action.payload.copyName)
      .map((response) => copyScenarioSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(copyScenarioError, error)))
      .takeUntil(action$.ofType(COPY_SCENARIO_ASYNC.CANCEL))
  )

const createNewCampaignFromScenarioEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(CREATE_CAMPAIGN_FROM_SCENARIO_ASYNC.INITIATE).mergeMap((action) =>
    api.awarenessCenter
      .createNewCampaignFromScenario(
        action.payload.id,
        undefined,
        store.getState().partnerOptions.selectedCompany?.value,
        !!store.getState().app.data.partner
      )
      .map((response) => createNewCampaignFromScenarioSuccess(response))
      .catch((error) =>
        Observable.of(epicsErrorHandler(createNewCampaignFromScenarioError(), error))
      )
      .takeUntil(action$.ofType(CREATE_CAMPAIGN_FROM_SCENARIO_ASYNC.CANCEL))
  )

export default combineEpics(
  fetchScenariosEpic,
  deleteScenarioEpic,
  copyScenarioEpic,
  createNewCampaignFromScenarioEpic
)
